(function () {
  function init(sectionEl) {
    const container = sectionEl.querySelector(".peek-slideshow");
    const track = sectionEl.querySelector(".peek-slideshow__track");
    const prevBtn = sectionEl.querySelector(".peek-slideshow__arrow--prev");
    const nextBtn = sectionEl.querySelector(".peek-slideshow__arrow--next");
    const dots = Array.from(sectionEl.querySelectorAll(".peek-slideshow__dot"));

    if (!container || !track) return;

    // Make sure track is scrollable (safety)
    track.style.overflowX = "auto";

    const autoplay = container.dataset.autoplay === "true";
    let interval = Number(container.dataset.interval || 5000);
    if (interval > 0 && interval < 100) interval = interval * 1000;

    let current = 0; // real index: 0..realCount-1
    let timer = null;

    let isProgrammaticScroll = false;
    let programmaticTimer = null;

    const clamp = (n, min, max) => Math.max(min, Math.min(max, n));

    const getCenterScrollLeft = (slideEl) => {
      const slideCenter = slideEl.offsetLeft + slideEl.offsetWidth / 2;
      const viewportCenter = track.clientWidth / 2;
      return slideCenter - viewportCenter;
    };

    // ---------- Loop setup (clone first/last) ----------
    // Remove existing clones (when section re-renders)
    track.querySelectorAll(".peek-slideshow__slide.is-clone").forEach((n) => n.remove());

    let slides = Array.from(track.querySelectorAll(".peek-slideshow__slide"));
    const realCount = slides.length;

    // If not enough slides, just do non-loop behavior
    const enableLoop = realCount >= 2;

    if (enableLoop) {
      const firstClone = slides[0].cloneNode(true);
      firstClone.classList.add("is-clone");
      firstClone.setAttribute("aria-hidden", "true");

      const lastClone = slides[realCount - 1].cloneNode(true);
      lastClone.classList.add("is-clone");
      lastClone.setAttribute("aria-hidden", "true");

      // prepend lastClone, append firstClone
      track.insertBefore(lastClone, slides[0]);
      track.appendChild(firstClone);

      // refresh slides (now includes clones)
      slides = Array.from(track.querySelectorAll(".peek-slideshow__slide"));
    }

    // real slides only (exclude clones)
    const realSlides = enableLoop ? slides.slice(1, slides.length - 1) : slides;

    // ---------- UI ----------
    const updateDots = () => {
      dots.forEach((d, i) => d.classList.toggle("is-active", i === current));
    };

    const setProgrammaticLock = (smooth) => {
      isProgrammaticScroll = true;
      if (programmaticTimer) window.clearTimeout(programmaticTimer);
      programmaticTimer = window.setTimeout(() => {
        isProgrammaticScroll = false;
      }, smooth ? 700 : 100);
    };

    const goToReal = (realIdx, smooth = true) => {
      if (realSlides.length === 0) return;

      current = clamp(realIdx, 0, realSlides.length - 1);
      updateDots();

      const targetEl = enableLoop ? slides[current + 1] : realSlides[current];
      const target = getCenterScrollLeft(targetEl);

      setProgrammaticLock(smooth);

      // Avoid scroll-snap "snap back" on init
      if (!smooth) {
        const prevSnap = track.style.scrollSnapType;
        track.style.scrollSnapType = "none";
        track.scrollLeft = target;
        // restore snap next tick
        requestAnimationFrame(() => {
          track.style.scrollSnapType = prevSnap || "";
          track.scrollLeft = target;
        });
      } else {
        track.scrollTo({ left: target, behavior: "smooth" });
      }
    };

    const next = () => {
      if (realSlides.length <= 1) return;
      goToReal(current >= realSlides.length - 1 ? 0 : current + 1);
    };

    const prev = () => {
      if (realSlides.length <= 1) return;
      goToReal(current <= 0 ? realSlides.length - 1 : current - 1);
    };

    const stop = () => {
      if (timer) window.clearInterval(timer);
      timer = null;
    };

    const start = () => {
      if (!autoplay || realSlides.length <= 1) return;
      stop();
      timer = window.setInterval(next, interval);
    };

    // ---------- Events ----------
    prevBtn?.addEventListener("click", (e) => {
      e.preventDefault();
      stop();
      prev();
      start();
    });

    nextBtn?.addEventListener("click", (e) => {
      e.preventDefault();
      stop();
      next();
      start();
    });

    dots.forEach((d, i) => {
      d.addEventListener("click", (e) => {
        e.preventDefault();
        stop();
        goToReal(i, true);
        start();
      });
    });

    // Pause on hover (desktop)
    container.addEventListener("mouseenter", stop);
    container.addEventListener("mouseleave", start);

    // Update current by scroll position + loop jump
    let raf = null;
    track.addEventListener(
      "scroll",
      () => {
        if (isProgrammaticScroll) return;

        if (raf) cancelAnimationFrame(raf);
        raf = requestAnimationFrame(() => {
          const center = track.scrollLeft + track.clientWidth / 2;

          // Loop jump: when user scrolls into clones, jump to the corresponding real slide
          if (enableLoop) {
            const firstReal = slides[1];
            const lastReal = slides[slides.length - 2];
            const lastClone = slides[0];
            const firstClone = slides[slides.length - 1];

            const firstRealMid = firstReal.offsetLeft + firstReal.offsetWidth / 2;
            const lastRealMid = lastReal.offsetLeft + lastReal.offsetWidth / 2;
            const lastCloneMid = lastClone.offsetLeft + lastClone.offsetWidth / 2;
            const firstCloneMid = firstClone.offsetLeft + firstClone.offsetWidth / 2;

            // If we're closer to a clone than real edges, jump
            if (Math.abs(center - lastCloneMid) < Math.abs(center - firstRealMid)) {
              // jump to last real
              setProgrammaticLock(false);
              track.scrollLeft = getCenterScrollLeft(lastReal);
              center; // noop
            } else if (Math.abs(center - firstCloneMid) < Math.abs(center - lastRealMid)) {
              // jump to first real
              setProgrammaticLock(false);
              track.scrollLeft = getCenterScrollLeft(firstReal);
              center; // noop
            }
          }

          // Determine best real slide by center distance
          let bestIdx = 0;
          let bestDist = Infinity;
          realSlides.forEach((s, i) => {
            const mid = s.offsetLeft + s.offsetWidth / 2;
            const dist = Math.abs(mid - center);
            if (dist < bestDist) {
              bestDist = dist;
              bestIdx = i;
            }
          });

          current = bestIdx;
          updateDots();
        });
      },
      { passive: true }
    );

    // ---------- Init ----------
    updateDots();

    // Start at first real slide (so clones give left peek naturally)
    current = 0;
    goToReal(0, false);

    // After images load, recenter once (improves first paint accuracy)
    const imgs = Array.from(sectionEl.querySelectorAll(".peek-slideshow__slide img"));
    let pending = 0;
    imgs.forEach((img) => {
      if (!img.complete) {
        pending++;
        img.addEventListener(
          "load",
          () => {
            pending--;
            if (pending === 0) goToReal(current, false);
          },
          { once: true }
        );
      }
    });
    // small safety recenter
    setTimeout(() => goToReal(current, false), 300);

    start();
  }

  function boot() {
    document.querySelectorAll(".peek-slideshow-section").forEach(init);
  }

  // Normal load
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }

  // Shopify theme editor: section reload
  document.addEventListener("shopify:section:load", (e) => {
    const section = e.target;
    if (section && section.classList && section.classList.contains("peek-slideshow-section")) {
      init(section);
    }
  });
})();
